import { ApplicationRoutes } from 'src/constants/applicationRoutes';

export const UnauthorizedRoutes = [
  {
    path: ApplicationRoutes.account.login,
    async lazy() {
      const component = await import('src/features/auth/Login');
      return { Component: component.LoginPage };
    }
  },
  {
    path: ApplicationRoutes.account.twoFactorLogin,
    async lazy() {
      const component = await import('src/features/auth/LoginTwoFactor');
      return { Component: component.LoginTwoFactor };
    }
  },
  {
    path: ApplicationRoutes.account.resetPassword,
    async lazy() {
      const component = await import('src/features/auth/ResetPassword');
      return { Component: component.ResetPasswordPage };
    }
  },
  {
    path: ApplicationRoutes.account.forgotPassword,
    async lazy() {
      const component = await import('src/features/auth/ForgotPassword');
      return { Component: component.ForgotPasswordPage };
    }
  },
  {
    path: ApplicationRoutes.account.logout,
    async lazy() {
      const component = await import('src/features/auth/Logout');
      return { Component: component.Logout };
    }
  },
  {
    path: ApplicationRoutes.account.reportingRequirementEdit,
    async lazy() {
      const component = await import('src/features/reportingRequirementEditor/ReportingRequirementEditPage');
      return { Component: component.ReportingRequirementEditPage };
    }
  },
  {
    path: ApplicationRoutes.account.loyaltyAccountEdit,
    async lazy() {
      const component = await import('src/features/loyaltyAccountEditor/LoyaltyAccountEditPage');
      return { Component: component.LoyaltyAccountEditPage };
    }
  }
];

export const ApprovalRoutes = [
  {
    path: ApplicationRoutes.approval.info,
    async lazy() {
      const component = await import('src/features/approval/ApprovalInformationPage');
      return { Component: component.ApprovalInformationPage };
    }
  }
];
